import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeCustomProp, makeStringProp } from '@/utils';
import { CheckboxGroup, RadioGroup } from 'vant';

const { name, bem } = createNamespaceBem('pkg-checkbox-group');

export type CheckboxType = 'radio' | 'checkbox';

const pkgCheckboxGroupProps = {
  modelValue: makeCustomProp<any>([Number, Array], []),
  type: makeStringProp<CheckboxType>('radio'),
};

export type PkgCheckboxGroupProps = ExtractPropTypes<typeof pkgCheckboxGroupProps>;

export default defineComponent({
  name,
  props: pkgCheckboxGroupProps,
  emits: ['update:modelValue'],
  setup(props, { emit, slots }) {
    const defaultValue = ref(props.modelValue);
    const onCheckboxChange = (data) => {
      emit('update:modelValue', data);
    };
    return () => (
      <div class={bem()}>
        {props.type === 'checkbox' ? (
          <CheckboxGroup class={bem('group')} v-model={defaultValue.value} onChange={onCheckboxChange}>
            {slots.default?.()}
          </CheckboxGroup>
        ) : (
          <RadioGroup class={bem('group')} v-model={defaultValue.value} onChange={onCheckboxChange}>
            {slots.default?.()}
          </RadioGroup>
        )}
      </div>
    );
  },
});
